import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';

@inheritSerialization(AbstractModel)
export class RideLimitPeriod extends AbstractModel {
  @autoserialize
  name: string;
}
